import React from 'react';
import { View, Text, TouchableOpacity, Platform, Linking } from 'react-native';
import { globalStyles } from '../styles/globalStyles';
import { BackgroundVideo } from '../components/BackgroundVideo';
import { getAuth } from 'firebase/auth';

let STRIPE_BUY_LINK = process.env.REACT_STRIPE_BUY_LINK || process.env.STRIPE_BUY_LINK || 'https://buy.stripe.com/fZu8wQ1FDgpi91p4OAbZe00';
// STRIPE_BUY_LINK = 'https://buy.stripe.com/test_8x26oI4hZ6oZ4kMb6M8EM00';


export function Plans({ navigation }) {

  const handleSubscribe = async () => {
    const auth = getAuth();
    const user = auth.currentUser;
    console.log(user);
    if (!user) {
      navigation.navigate('Login');
      return;
    }

      
    const stripeUrl = `${STRIPE_BUY_LINK}?prefilled_email=${encodeURIComponent(user.email)}`;
    
    if (Platform.OS === 'web') {
      window.open(stripeUrl, '_blank');
    } else {
      await Linking.openURL(stripeUrl);
    }
  };

  return (
    <View style={globalStyles.container}>
      <BackgroundVideo />
      <View style={[globalStyles.overlay, globalStyles.plansContent]}>
        <View style={globalStyles.plansHeader}>
          <Text style={globalStyles.plansTitle}>Choose Your Plan</Text>
          <Text style={globalStyles.plansSubtitle}>Unlock all features and support the community</Text>
        </View>

        <View style={globalStyles.planCard}>
          <View style={globalStyles.planHeader}>
            <Text style={globalStyles.planName}>Premium Membership</Text>
            <View style={globalStyles.priceContainer}>
              <Text style={globalStyles.priceCurrency}>$</Text>
              <Text style={globalStyles.priceAmount}>6</Text>
              <Text style={globalStyles.pricePeriod}>/month</Text>
            </View>
          </View>

          <View style={globalStyles.featuresContainer}>
            <Text style={globalStyles.featuresTitle}>What's Included:</Text>
            <View style={globalStyles.featureItem}>
              <Text style={globalStyles.featureIcon}>✓</Text>
              <Text style={globalStyles.featureText}>Save Unlimited Venues</Text>
            </View>
            <View style={globalStyles.featureItem}>
              <Text style={globalStyles.featureIcon}>✓</Text>
              <Text style={globalStyles.featureText}>Create tour folders</Text>
            </View>
            <View style={globalStyles.featureItem}>
              <Text style={globalStyles.featureIcon}>✓</Text>
              <Text style={globalStyles.featureText}>Access more search filters</Text>
            </View>
            <View style={globalStyles.featureItem}>
              <Text style={globalStyles.featureIcon}>✓</Text>
              <Text style={globalStyles.featureText}>Priority Support</Text>
            </View>
            <View style={globalStyles.featureItem}>
              <Text style={globalStyles.featureIcon}>✓</Text>
              <Text style={globalStyles.featureText}>Early Access to New Features</Text>
            </View>

          </View>

          <TouchableOpacity 
            style={globalStyles.subscribeButton}
            onPress={handleSubscribe}
          >
            <Text style={globalStyles.subscribeButtonText}>Subscribe Now</Text>
          </TouchableOpacity>

          <Text style={globalStyles.guaranteeText}>Cancel or Pause at any time</Text>
        </View>
      </View>
    </View>
  );
}
